/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_DescriptionInputs */

const en_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn text, photos, and reference clips into short videos and images with leading AI models. Edit, extend, and upscale in one place.`)
};

const es_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto, fotos y clips de referencia en videos cortos e imágenes con los mejores modelos de IA. Edita, extiende y mejora en un solo lugar.`)
};

/**
* | output |
* | --- |
* | "Turn text, photos, and reference clips into short videos and images with leading AI models. Edit, extend, and upscale in one place." |
*
* @param {Site_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const site_description = /** @type {((inputs?: Site_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_description(inputs)
	return es_site_description(inputs)
});